const pillsSpace = () => {
  setTimeout(() => {
    if (
      !document.querySelectorAll(
        "#FacetFiltersPillsForm .active-facets__items facet-remove"
      )
    )
      return;
    const items = document.querySelectorAll(
      "#FacetFiltersPillsForm .active-facets__items facet-remove"
    );
    let currentTop = null;
    let firstInEachRow = [];

    items.forEach((item) => {
      const top = item.offsetTop;

      if (top !== currentTop) {
        firstInEachRow.push(item);
        currentTop = top;
        item.querySelector("a").classList.add("first-in-row");
      } else {
        item.querySelector("a").classList.remove("first-in-row");
      }
    });

    fadeScrollEffect();
  }, 500);
};

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    if (this.classList.contains("facets_tags")) return;
    this.cleanupFocusTrap = null;
    this.lastFocusedBeforeOpen = null;
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    const facetButton = this.querySelector(".facets__button-show");

    const facetsContainer = this.querySelector(".facets__container");
    if (facetsContainer) {
      setTimeout(() => {
        facetsContainer.style.display = "flex";
      }, 600);
    }

    if (facetButton) {
      facetButton.onclick = (event) => {
        let labelHide = event.currentTarget.querySelector(".label-hide");
        let labelShow = event.currentTarget.querySelector(".label-show");

        let isStandard = event.currentTarget.classList.contains("standard");

        setTimeout(() => {
          labelHide.classList.toggle("hidden");
          labelShow.classList.toggle("hidden");

          if (isStandard) {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }
        }, 350);

        let container = labelHide
          .closest("form")
          .querySelector(".facets__container");
        let containerChildren = container.querySelectorAll("*");

        containerChildren.forEach((child) =>
          child.classList.add("overflow-hidden")
        );
        container.classList.toggle("active");

        setTimeout(
          () =>
            containerChildren.forEach((child) =>
              child.classList.remove("overflow-hidden")
            ),
          700
        );

        const modal = container;

        const openNow = modal.classList.contains("active");

        if (openNow) {
          this.lastFocusedBeforeOpen = document.activeElement;

          // Make container focusable as fallback
          modal.setAttribute("tabindex", "-1");

          // Focus inside after animation/layout
          setTimeout(() => {
            const wrapper =
              modal.querySelector("#FacetsWrapperDesktop") || modal;
            wrapper.setAttribute("tabindex", "-1");
            focusFirstIn(wrapper);
          }, 0);

          // Start trapping focus + close when focus leaves
          if (this.cleanupFocusTrap) this.cleanupFocusTrap();
          this.cleanupFocusTrap = createFocusTrap(
            modal,
            () => {
              // close modal if escape pressed OR focus left
              modal.classList.remove("active");
              modal?.closest(".facets-container")?.classList.remove("active");
              modal
                ?.closest(".collection-wrapper--vertical")
                ?.classList.remove("active");
              document.body.classList.remove("overflow-hidden");
              setTimeout(
                () => document.body.classList.remove("filter-open"),
                700
              );

              if (this.cleanupFocusTrap) this.cleanupFocusTrap();
              this.cleanupFocusTrap = null;

              // return focus to the button
              this.lastFocusedBeforeOpen?.focus?.();
            },
            {
              allowOutside: (el) =>
                facetButton === el || facetButton.contains(el),
            }
          );
        } else {
          // closed by clicking the button again
          if (this.cleanupFocusTrap) this.cleanupFocusTrap();
          this.cleanupFocusTrap = null;

          this.lastFocusedBeforeOpen?.focus?.();
        }

        container?.closest(".facets-container")?.classList.toggle("active");
        container
          ?.closest(".collection-wrapper--vertical")
          ?.classList.toggle("active");
        if (
          !container.classList.contains("standard") ||
          window.innerWidth < 990
        ) {
          document.body.classList.toggle(`overflow-hidden`);
          document.body.classList.toggle("filter-open");
        }

        if (
          document.querySelector(
            ".facets__container--horizontal:not(.active)"
          ) != null
        ) {
          let horizontalFilters = document.querySelector(
            ".facets__container--horizontal:not(.active)"
          );
          horizontalFilters.classList.add("visible_container");

          setTimeout(
            () => horizontalFilters.classList.remove("visible_container"),
            600
          );
        }

        container.addEventListener("click", (event) => {
          if (event.target !== container) return;

          if (container.querySelector(".facets__wrapper:hover") == null) {
            container.classList.remove("active");
            container?.closest(".facets-container")?.classList.remove("active");
            container
              ?.closest(".collection-wrapper--vertical")
              ?.classList.remove("active");
            document.body.classList.remove(`overflow-hidden`);

            setTimeout(
              () => document.body.classList.remove(`filter-open`),
              700
            );
          }
        });
      };

      const facetCloseButton = this.querySelector(".facets-modal__close");
      facetCloseButton.addEventListener("click", () => {
        let container = facetCloseButton.closest(".facets__container");
        container.classList.remove("active");
        container?.closest(".facets-container")?.classList.remove("active");
        container
          ?.closest(".collection-wrapper--vertical")
          ?.classList.remove("active");
        document.body.classList.remove(`overflow-hidden`);
        setTimeout(() => document.body.classList.remove(`filter-open`), 700);

        if (this.cleanupFocusTrap) this.cleanupFocusTrap();
        this.cleanupFocusTrap = null;

        this.lastFocusedBeforeOpen?.focus?.();
      });

      const collectionGridSection =
        document.querySelector(".collection-grid-section") ||
        document.querySelector(".section-search");
      let prevWidth = 0;
      const sectionResizeObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
      });
      sectionResizeObserver.observe(collectionGridSection);
    }

    const checkboxes = document.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter input[type="checkbox"]'
    );
    const removebtn = document.querySelector(
      "#FacetFiltersFormMobile .facets-tag-wrapper"
    );
    const allChecked = Array.from(checkboxes).some(
      (checkbox) => checkbox.checked
    );

    if (allChecked) {
      removebtn?.classList.remove("active");
    } else {
      removebtn?.classList.add("active");
    }
  }

  static setupSorting() {
    if (document.getElementById("facetsSortName") != null) {
      const select = document.getElementById("facetsSortName");
      const list = document.querySelector(".facets__sorting--list");

      select.addEventListener("pointerdown", (e) => {
        if (select.classList.contains("open")) {
          select.classList.remove("open");
        } else {
          select.classList.add("open");
        }
      });

      select.addEventListener("focusin", () => {
        select.classList.add("open");
      });

      select.addEventListener("focusout", (e) => {
        const next = e.relatedTarget;
        if (next && (select.contains(next) || list.contains(next))) {
          return;
        }
        select.classList.remove("open");
      });

      list.addEventListener("focusout", (e) => {
        const target = e.relatedTarget;
        if (target && (select.contains(target) || list.contains(target))) {
          return;
        }
        select.classList.remove("open");
      });

      if (list.querySelector(".facets__sorting--item") != null) {
        list.querySelectorAll(".facets__sorting--item").forEach((item) => {
          item.addEventListener("keydown", (e) => {
            if (e.key !== "Enter") return;

            e.preventDefault();

            const input = item.matches("input")
              ? item
              : item.querySelector("input");

            input?.click();
          });
        });
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    initFacetsSwiper();
    pillsSpace();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        const sliders = document.querySelectorAll(".product-card-js");

        sliders.forEach((slider, index) => {
          const productSlider = new Swiper(slider, {
            pagination: {
              el: ".product-pagination .swiper-pagination",
              type: "progressbar",
            },
            navigation: {
              nextEl: ".product-button-group .swiper-button-next",
              prevEl: ".product-button-group .swiper-button-prev",
            },
            allowTouchMove: true,
            breakpoints: {
              990: {
                allowTouchMove: false,
              },
            },
          });
        });

        initFacetsSwiper();
        pillsSpace();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    initFacetsSwiper();
    pillsSpace();
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    if (
      document.querySelector(".js-load-more") ||
      document.querySelector(".js-infinite-scroll")
    )
      loadMore();

    colorSwatches();
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount")?.innerHTML;
    if (count == null) return;

    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );

    const checkboxes = document.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter input[type="checkbox"]'
    );
    const removebtn = document.querySelector(
      "#FacetFiltersFormMobile .facets-tag-wrapper"
    );
    const allChecked = Array.from(checkboxes).some(
      (checkbox) => checkbox.checked
    );

    if (allChecked) {
      removebtn?.classList.remove("active");
    } else {
      removebtn?.classList.add("active");
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    FacetFiltersForm.setupSorting();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const currentForm = event.target.closest("form");
      sortFilterForms.forEach((form) => {
        if (
          form.id === "FacetSortForm" ||
          form.id === "FacetFiltersForm" ||
          form.id === "FacetFiltersFormMobile" ||
          form.id === "FacetSortDrawerForm"
        ) {
          const noJsElements = document.querySelectorAll(".no-js-list");
          noJsElements.forEach((el) => el.remove());
          if (currentForm === form) {
            forms.push(this.createSearchParams(form));
          } else {
            const searchParamsWithoutProductType =
              this.createSearchParams(form)
                ?.split("&")
                ?.filter(
                  (element) => !element.startsWith("filter.p.product_type")
                )
                ?.join("&") || "";

            forms.push(searchParamsWithoutProductType);
          }
        }
      });
      this.onSubmitForm(forms.join("&"), event);
      initFacetsSwiper();
      pillsSpace();
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);

    const removebtn = document.querySelector(
      "#FacetFiltersFormMobile .facets-tag-wrapper"
    );
    removebtn?.classList.add("active");
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.setupSorting();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll(".field__input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") {
      maxInput.setAttribute("min", 0);
    }
    if (maxInput.value === "") {
      minInput.setAttribute("max", maxInput.getAttribute("max"));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range"
    );
    inputRangeWrappers.forEach((inputWrapper) => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = Number(inputRangeTo.max) - Number(inputRangeTo.min);
      const fromCurrent =
        Number(inputRangeFrom.value) - Number(inputRangeTo.min);
      const toCurrent = Number(inputRangeTo.value) - Number(inputRangeTo.min);
      const minRange = (fromCurrent / range) * 100;
      const maxRange = (toCurrent / range) * 100;

      inputWrapper.setAttribute(
        "style",
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    });
  }

  controlSlider() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range"
    );
    const inputNumberWrappers = document.querySelectorAll(
      ".facets__price .facets__price-wrapper"
    );

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom =
        inputNumberWrappers[index].querySelectorAll(".field__input")[0];
      const inputNumberTo =
        inputNumberWrappers[index].querySelectorAll(".field__input")[1];

      inputRangeFrom.oninput = () => {
        const from = Number(inputRangeFrom.value);
        const to = Number(inputRangeTo.value);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      };

      if (Number(inputRangeTo.value) <= 0) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = Number(inputRangeFrom.value);
        const to = Number(inputRangeTo.value);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        } else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      };
    });
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range"
    );
    const inputNumberWrappers = document.querySelectorAll(
      ".facets__price .facets__price-wrapper"
    );

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll(".field__input");
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom =
        inputRangeWrappers[index].querySelectorAll(".field__range")[0];
      const inputRangeTo =
        inputRangeWrappers[index].querySelectorAll(".field__range")[1];

      inputNumberFrom.oninput = () => {
        const from = Number(inputNumberFrom.value);
        const to = Number(inputNumberTo.value);

        if (to && from > to) {
          inputRangeFrom.value = to;
        } else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      };

      inputNumberTo.oninput = () => {
        const from = Number(inputNumberFrom.value);
        const to = Number(inputNumberTo.value);

        if (to >= from) {
          inputRangeTo.value = to;
        } else {
          inputRangeTo.value = from;
        }

        this.fillSlider();
      };

      inputNumberFrom.onblur = () => {
        if (inputNumberFrom.value === "") return;
        const from = Number(inputNumberFrom.value);
        const min = Number(inputNumberFrom.getAttribute("min"));
        const max = Number(inputNumberFrom.getAttribute("max"));

        if (from < min) {
          inputRangeFrom.value = min;
          inputNumberFrom.value = min;
        } else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      };

      inputNumberTo.onblur = () => {
        if (inputNumberTo.value === "") return;
        const to = Number(inputNumberTo.value);
        const min = Number(inputNumberTo.getAttribute("min"));
        const max = Number(inputNumberTo.getAttribute("max"));

        if (to > max) {
          inputRangeTo.value = max;
          inputNumberTo.value = max;
        } else {
          inputRangeTo.value = to;
        }

        this.fillSlider();
      };
    });
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

function getElementTop(element) {
  const rectTop = element.getBoundingClientRect().top;
  const pageTop =
    rectTop +
    (window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0);
  return pageTop;
}

function detectSticky() {
  const sticky = document.querySelector(
    ".collection-wrapper .facets-container"
  ); // your sticky element

  let isStuck = false;

  window.addEventListener("scroll", () => {
    const rect = sticky.getBoundingClientRect();
    const stuckNow = rect.top === 0; // sticky is touching viewport top

    if (stuckNow && !isStuck) {
      // Just stuck
      isStuck = true;
      sticky.classList.add("is-sticky");
    }

    if (!stuckNow && isStuck && rect.top > 0) {
      // Just unstuck (scrolling up)
      isStuck = false;
      sticky.classList.remove("is-sticky");
    }

    if (!stuckNow && isStuck && rect.top < 0) {
      // Just unstuck (scrolling down / leaving bottom)
      isStuck = false;
      sticky.classList.remove("is-sticky");
    }
  });
}

function initFacetsSwiper() {
  if (document.querySelectorAll(".facets__display.swiper").length > 0) {
    document.querySelectorAll(".facets__display.swiper").forEach((slider) => {
      const facetTagSlider = new Swiper(slider, {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 24,
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
        allowTouchMove: true,
      });

      const prevBtn = slider.querySelector(".swiper-button-prev");
      if (!prevBtn) return;

      const swiper = prevBtn.closest(".swiper");

      const updateClass = () => {
        const isDisabled = prevBtn.getAttribute("aria-disabled") === "true";
        swiper.classList.toggle("swiper-prev-enabled", !isDisabled);
      };

      // initial state
      updateClass();

      // observe aria-disabled changes
      const observer = new MutationObserver(updateClass);

      observer.observe(prevBtn, {
        attributes: true,
        attributeFilter: ["aria-disabled"],
      });
    });
  }
}

function setupLongFiltersToggle(e) {
  var button = e.currentTarget;
  button.classList.toggle("open");
}

function setupLongFiltersKeydown(e) {
  const button = e.currentTarget;

  button.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      button.click();
    }
  });
}

function getFocusable(container) {
  if (!container) return [];
  const selectors = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])',
  ];
  return Array.from(container.querySelectorAll(selectors.join(","))).filter(
    (el) => !el.hasAttribute("disabled") && el.offsetParent !== null
  );
}

function focusFirstIn(container) {
  const focusables = getFocusable(container);
  (focusables[0] || container).focus?.();
}

function createFocusTrap(modalEl, onEscapeOrLeave, options = {}) {
  if (!modalEl) return () => {};

  const { allowOutside = (el) => false } = options;

  const focusFirst = () => {
    const f = getFocusable(modalEl);
    (f[0] || modalEl).focus?.();
  };

  const focusLast = () => {
    const f = getFocusable(modalEl);
    (f[f.length - 1] || modalEl).focus?.();
  };

  const onKeyDown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      onEscapeOrLeave?.();
      return;
    }

    if (e.key !== "Tab") return;

    const active = document.activeElement;

    // ✅ Key fix: if focus is OUTSIDE modal (e.g., on the trigger button),
    // first Tab should move focus INTO the modal instead of leaving/closing it.
    if (!modalEl.contains(active) && allowOutside(active)) {
      e.preventDefault();
      e.shiftKey ? focusLast() : focusFirst();
      return;
    }

    // If focus is outside and NOT allowed — treat as leaving
    if (!modalEl.contains(active) && !allowOutside(active)) {
      onEscapeOrLeave?.();
      return;
    }

    const focusables = getFocusable(modalEl);
    if (!focusables.length) {
      e.preventDefault();
      modalEl.focus?.();
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  };

  const onFocusIn = (e) => {
    // Allow trigger (or other allowed elements) to keep focus while modal is open
    if (allowOutside(e.target)) return;

    if (!modalEl.contains(e.target)) {
      onEscapeOrLeave?.();
    }
  };

  document.addEventListener("keydown", onKeyDown, true);
  document.addEventListener("focusin", onFocusIn, true);

  return () => {
    document.removeEventListener("keydown", onKeyDown, true);
    document.removeEventListener("focusin", onFocusIn, true);
  };
}

if (document.querySelector("summary").length != null) {
  document.querySelectorAll("summary").forEach((summary) => {
    summary.addEventListener("click", (e) => {
      e.preventDefault();
      const details = summary.parentNode;
      details.open = !details.open;
    });
  });
}

if (Shopify.designMode) {
  document.addEventListener("shopify:section:select", (e) => {
    initFacetsSwiper();
  });

  document.addEventListener("shopify:section:deselect", (e) => {
    initFacetsSwiper();
  });

  document.addEventListener("shopify:section:load", (e) => {
    initFacetsSwiper();
  });

  document.addEventListener("shopify:section:unload", (e) => {
    initFacetsSwiper();
  });

  document.addEventListener("shopify:block:select", (e) => {
    initFacetsSwiper();
  });

  document.addEventListener("shopify:block:deselect", (e) => {
    initFacetsSwiper();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initFacetsSwiper();
  detectSticky();
});
